
namespace GeniuzPOS.Customer {

    @Serenity.Decorators.registerClass()
    export class CsCustGroupGrid extends Serenity.EntityGrid<CsCustGroupRow, any> {
        protected getColumnsKey() { return CsCustGroupColumns.columnsKey; }
        protected getDialogType() { return CsCustGroupDialog; }
        protected getIdProperty() { return CsCustGroupRow.idProperty; }
        protected getInsertPermission() { return CsCustGroupRow.insertPermission; }
        protected getLocalTextPrefix() { return CsCustGroupRow.localTextPrefix; }
        protected getService() { return CsCustGroupService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}